import { useEffect, useRef } from 'react';
var useAsyncEffect = function (effect, deps) {
    var cleanUpRef = useRef();
    useEffect(function () {
        cleanUpRef.current = undefined;
        var cleanUp = effect();
        if (cleanUp instanceof Promise)
            cleanUp.then(function (cleanUp) { return cleanUpRef.current = cleanUp; });
        else
            cleanUpRef.current = cleanUp;
        return function () {
            cleanUpRef.current && cleanUpRef.current();
        };
    }, deps);
};
export default useAsyncEffect;
//# sourceMappingURL=useAsyncEffect.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@hilma/tools/dist/react/hooks/useAsyncEffect.js
// module id = 79
// module chunks = 1